export enum FormState {
  Stars = 'Stars',
  Description = 'Description',
  Marks = 'Marks',
}

export enum PartnerType {
  ECF = 'ECF',
  AvisSolution = 'AvisSolution',
}
